<template>
  <button
    v-if="color == 'white'"
    :disabled="$store.state.general.localLoadingSpinner ? true : disabled"
    class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-150"
    @click="$emit('click')"
  >
    {{ label }}
    <div class="ml-2 -mr-1 h-5 w-5">
      <slot></slot>
    </div>
  </button>
  <button
    v-else-if="color == 'indigo'"
    :disabled="$store.state.general.localLoadingSpinner ? true : disabled"
    class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    @click="$emit('click')"
  >
    {{ label }}
    <div class="ml-2 -mr-1 h-5 w-5">
      <slot></slot>
    </div>
  </button>
  <button
    v-else-if="color == 'red'"
    :disabled="$store.state.general.localLoadingSpinner ? true : disabled"
    class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
    @click="$emit('click')"
  >
    {{ label }}
    <div class="ml-2 -mr-1 h-5 w-5">
      <slot></slot>
    </div>
  </button>
</template>

<script>
export default {
  props: ['label', 'color', 'disabled'],
};
</script>
